import React from "react";
import logger from "logger";
import AngSelect from "Common/Angular/AngSelect";

export default function(props) {
  const {
    label,
    taskConfig,
    param,
    bosslist = [],
    setValue,
    isNormalBoss = false,
  } = props;
  return (
    <div style={{ padding: "7px" }}>
      <div>{label}</div>
      <div>
        <AngSelect
          required
          ng-model={taskConfig[param]}
          options={bosslist.map((boss) => {
            let label = boss.bossname + "(Lv." + boss.bosslevel + ")";
            if (isNormalBoss) {
              label = boss;
            }
            return {
              label,
              value: boss,
            };
          })}
          onChange={(selectedValue) => {
            setValue({ target: { value: selectedValue.value } }, param);
          }}
        />
      </div>
    </div>
  );
}
